
import { mixins } from 'vue-class-component'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { CampsiteDetails } from '~/apps/campsite-details/types'
import AuthMixin from '~/mixins/AuthMixin'
import { getAddReviewMachine } from '../inversify.config'
import { AddReviewStateMachineInterpreter } from '../machine'

@Component({
  layout: 'user-account',
})
export default class PostReviewMain extends mixins(AuthMixin) {
  @Prop({ required: true })
    token: string

  @Prop({ required: true })
    campsite: CampsiteDetails

  @Prop()
    setBackButtonVisibility?: (boolean) => null

  get campsiteName() {
    return this.campsite.name
  }

  get campsiteSlug() {
    return this.campsite.slug
  }

  machine: AddReviewStateMachineInterpreter | null = null
  context: AddReviewStateMachineInterpreter['state']['context'] | null = null
  state: AddReviewStateMachineInterpreter['state'] | null = null

  head() {
    const campsiteName = this.campsite.name
    const hierarchyTextShort = this.campsite.hierarchyTextShort
    const title = this.$i18n.t('Review {campsiteName}, {town}', {
      campsiteName,
      hierarchyTextShort,
    }) as string
    const description = this.$i18n.t('Rate your stay at {campsiteName}*', {
      campsiteName,
    }) as string
    return {
      title: title + ' | Pitchup.com',
      meta: [
        {
          hid: 'description',
          name: 'description',
          property: 'og:description',
          content: description,
        },
      ],
    }
  }

  authMounted() {
    this.machine = getAddReviewMachine(this.$route.params.lang || 'en-gb')
    if (!this.machine) {
      throw new Error('no review machine')
    }
    this.machine
      .onTransition((state, _event) => {
        if (state.changed) {
          this.state = state
          this.context = state.context
        }
      })
      .start()
    this.validateUserCanAdd()
  }

  submit(reviewData): void {
    const booking = this.booking
    if (!booking) {
      throw new Error('no booking in reviews')
    }
    this.machine?.send({
      type: 'SUBMIT_REVIEW',
      token: this.token,
      campsiteSlug: this.campsiteSlug,
      reviewData: { ...reviewData, visitDate: booking.arrive },
    })
  }

  private validateUserCanAdd() {
    if (this.token) {
      this.machine?.send({
        type: 'CHECK_GUEST_CAN_ADD',
        token: this.token,
        campsiteSlug: '',
      })
    } else if (this.isLoggedIn) {
      this.machine?.send({
        type: 'CHECK_USER_CAN_ADD',
        token: this.token,
        campsiteSlug: this.campsiteSlug,
      })
    } else {
      const langPrefix =
        this.$i18n.locale !== 'en-gb' ? this.$i18n.locale + '/' : ''
      void this.$router.push(`${langPrefix}/`)
    }
  }

  getCampsiteLinkProps() {
    if (this.context && this.context.reviewId) {
      return {
        hierarchyPath: this.campsite.path,
        slug: this.campsite.slug,
        reviewId: this.context.reviewId,
        excludeType: 'postCampsiteReview',
        forceReviewId: true,
      }
    }
    return {
      hierarchyPath: this.campsite.path,
      slug: this.campsite.slug,
      excludeType: 'postCampsiteReview',
    }
  }

  get isAddedState() {
    return this.state?.matches('added')
  }

  get isErrorsState() {
    return this.state?.matches('errors')
  }

  get booking() {
    return this.context?.booking
  }

  @Watch('isAddedState')
  isAddedStateChanged(isAdded) {
    if (this.setBackButtonVisibility) {
      this.setBackButtonVisibility(!isAdded)
    }
  }
}
